<template>
    <div id="vehicle-warranty-detail" class="admin-page-content asset-view list-view" v-if="vehicleId != '' && canAccessPage">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <section class="bg-white data-table border-top-table-fl">
            <h2>Warranty Coverage</h2>
            <vue-good-table ref="listAssetWarrantiesTable" title="Asset Warranties"
                :columns="assetColumns" :rows="rows"
                max-height="600px" :totalRows="totalRecords" :pagination-options="{
                    enabled: true,
                    position: 'top',
                    mode: 'records',
                    perPage: 50,
                    perPageDropdown: [50, 100],
                    dropdownAllowAll: false,
                }"
                :search-options="{
                    enabled: false,
                    placeholder: 'Search Asset Warranties',
                }"
                :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                }"
                :sort-options="{
                    enabled: true,
                }"
            >
                <div slot="emptystate">
                    No Data Found.
                </div>
                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                    <div :key="key">
                        <template v-if="props.column.field == 'code'">
                            <router-link class="color-blue" target="_blank" title="View Warranty"
                                v-bind:to="{ name: 'WarrantyView', params: { id: props.row.id } }">
                                {{ props.row.code }}
                            </router-link>
                        </template>
                        <template v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </template>
                    </div>
                </template>
            </vue-good-table>
        </section>
    </div>
</template>
<script>
import Vue from 'vue';
import { commonMixins } from '../mixins/commonMixins';
import { dataTableMixins } from '../mixins/dataTableMixins';
import { contractMixins } from '../mixins/contractMixins';


export default {
    name: "VehicleWarrantyDetails",
    mixins: [commonMixins, dataTableMixins, contractMixins],
    data: () => ({
        vehicleId: '',
        loading: false,
        assetColumns: [
            {
                label: 'Type',
                field: 'description',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Type', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable: true
            },
            {
                label: 'Years',
                field: 'years',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Years', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable: true
            },
            {
                label: 'Miles',
                field: 'miles',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Miles', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable: true
            },
            {
                label: 'End Date',
                field: 'end_date',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions: [],
        canAccessPage: false,
        isParentVehicleView: false,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_list_warranty') {
                        self.canAccessPage = true;
                        break;
                    }
                }
                if(this.isParentVehicleView){
                    this.getAssetWarranties(this.vehicleId);
                }
            }

        }
    },
    mounted: function () {
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            this.vehicleId = segments[3];
            this.isParentVehicleView = true;
        }
      for(const element of this.assetColumns) {
        if (element.field === 'miles'){
          this.$set(element, 'label', this.distance_unit);
        }
      }
        this.getPermissions();
    },
    methods: {
        getAssetWarranties(id) {
            if (this.canAccessPage) {

                var self = this;
                self.loading = true;
                self.vehicleId = id;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty/asset/" + self.vehicleId,
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            if (self.rows === undefined) {
                                self.rows = [];
                            }

                        }
                        if(self.isParentVehicleView){
                            self.emitDataToParent();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'asset-load-view')

                    }
                });
            }
        },
        emitDataToParent(){
            this.$emit("vehicle-warranty-data",this.rows);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/VehicleWarrantyDetails.vue